import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  completedThisMonth: "Completed This Month",
  flowInstances: "Flow instances",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    completedThisMonth: "Terminés ce mois-ci",
    flowInstances: "Instances de parcours",
  },
  es_ES: {
    completedThisMonth: "Completados este mes",
    flowInstances: "Instancias de flujo",
  },
  pt_BR: {
    completedThisMonth: "Concluídos este mês",
    flowInstances: "Instâncias de fluxo",
  },
  de_DE: {
    completedThisMonth: "Diesen Monat abgeschlossen",
    flowInstances: "Flow-Instanzen",
  },
  it_IT: {
    completedThisMonth: "Completati questo mese",
    flowInstances: "Istanze di flusso",
  },
  ar: {
    completedThisMonth: "المكتمل هذا الشهر",
    flowInstances: "نُسخ المسارات",
  },
  ja_JP: {
    completedThisMonth: "今月の完了",
    flowInstances: "フローインスタンス",
  },
  hi_IN: {
    completedThisMonth: "इस माह पूर्ण",
    flowInstances: "फ़्लो इंस्टेंस",
  },
  zh_CN: {
    completedThisMonth: "本月完成",
    flowInstances: "流程实例",
  },
  zh_TW: {
    completedThisMonth: "本月完成",
    flowInstances: "流程執行個體",
  },
  nl_NL: {
    completedThisMonth: "Voltooid deze maand",
    flowInstances: "Flowinstanties",
  },
  nb_NO: {
    completedThisMonth: "Fullført denne måneden",
    flowInstances: "Flytinstanser",
  },
  sv_SE: {
    completedThisMonth: "Slutförda denna månad",
    flowInstances: "Flödesinstanser",
  },
  fi_FI: {
    completedThisMonth: "Valmistuneet tässä kuussa",
    flowInstances: "Prosessi-instanssit",
  },
  da_DK: {
    completedThisMonth: "Gennemført denne måned",
    flowInstances: "Forløbsinstanser",
  },
  is_IS: {
    completedThisMonth: "Lokið í þessum mánuði",
    flowInstances: "Ferlistilvik",
  },
};
